module.exports = __webpack_public_path__ + "front/img/10_5.835a81d3.png";